/**
 * Custom hook for managing feature flags data and filtering
 */

import { useMemo } from 'react';
import { FeatureFlagAttributes } from '@/types/admin/featureFlags';
import { filterFeatureFlags, groupFlagsByOrganization } from '../utils/featureFlagsUtils';

interface UseFeatureFlagsDataProps {
  data?: { response?: FeatureFlagAttributes[] };
  searchTerm: string;
}

export const useFeatureFlagsData = ({ data, searchTerm }: UseFeatureFlagsDataProps) => {
  // Filter flags based on search term
  const filteredFlags = useMemo(() => {
    if (!data?.response) return [];
    return filterFeatureFlags(data.response, searchTerm);
  }, [data, searchTerm]);

  // Group flags by organization
  const groupedFlags = useMemo(() => {
    return groupFlagsByOrganization(filteredFlags);
  }, [filteredFlags]);

  // Convert to array for list rendering
  const organizationSections = useMemo(() => {
    return Object.entries(groupedFlags).map(([orgName, flags]) => ({
      orgName,
      flags,
    }));
  }, [groupedFlags]);

  return {
    filteredFlags,
    groupedFlags,
    organizationSections,
  };
};

